import gql from 'graphql-tag';

import recentObjectsFragment from '../fragments/recentObjectsFragment';

export const queryRecentObjects = gql`
  query recentObjects {
    recentObjects {
      ...recentObjectsFragment
    }
  }
  ${recentObjectsFragment}
`;
export default queryRecentObjects;
